{
    "message": {
        "name": "Název",
        "hour": "Hodina",
        "day": "Den",
        "month": "Měsíc",
        "year": "Rok",
        "show": "Zobrazit",
        "liters": "litry",
        "price_estimate": "orientační cena",
        "edit": "Upravit",
        "move_up": "Posunout nahoru",
        "move_down": "Posunout dolů",
        "edit_order": "Upravit pořadí",
        "finish_ordering": "Dokončit řazení",
        "notes": "Poznámky (v přípravě)",
        "alarms": "Alarmy",
        "sharing": "Sdílení",
        "remove": "Odstranit",
        "confirm_remove_object": "Opravdu chcete smazat objekt?",
        "confirm_remove_homebase": "Opravdu chcete smazat tuto homebase?",
        "confirm_remove_prefix": "Opravdu chcete smazat",
        "postfix_building": "budovu",
        "postfix_unit": "byt/kancelář",
        "postfix_transmitter": "vysílač",
        "postfix_validation_transmitter": "kontrolní vysílač",
        "confirm_remove_transmitter": "Jste si jistí, že chcete vysílač opravdu odstranit?",
        "confirm_remove_transmitter_billing": "Odstraněním může dojít ke zkreslení dat pro rozúčtování.",
        "confirm_remove_transmitter_unused": "Již nepoužívané avšak dříve aktivní vysílače nikdy neodstraňujte.",
        "confirm_remove_transmitter_mistake": "Odstranit, vysílač byl vložen omylem",
        "cold_water": "Studená voda",
        "hot_water": "Teplá voda",
        "cold_and_hot_water": "Studená i teplá voda celkem",
        "total_water": "Voda celkem",
        "add_building": "Přidat budovu",
        "edit_building": "Upravit budovu",
        "cancel": "Storno",
        "loading": "Načítání…",
        "no_records": "Žádné záznamy",
        "create": "Vytvořit",
        "street": "Ulice",
        "house_number": "Č.p.",
        "city": "Město",
        "zip": "PSČ",
        "country": "Země",
        "price_estimate_cold_water": "Cena za 1 litr studené vody",
        "price_estimate_hot_water": "Cena za 1 litr teplé vody",
        "price_estimate_power": "Cena za 1 kWh",
        "price_estimate_heat": "Cena za dílek",
        "price_estimate_water": "Cena za 1 litr vody",
        "from_parent_object": "Z nadřazeného objektu",
        "price_unit": "Kč / litr",
        "save": "Uložit",
        "add_homebase": "Přidat základnu",
        "building": "Budova",
        "serial_number": "Sériové číslo",
        "add_transmitter": "Přidat vysílač",
        "edit_transmitter": "Upravit vysílač",
        "transmitter": "Vysílač",
        "transmitters": "Vysílače",
        "transmitter_name_placeholder": "např. Koupelna",
        "unit": "Byt/kancelář",
        "water_meter": "Vodoměr",
        "not_used": "není používaný",
        "correction": "Počáteční stav (korekce)",
        "correction_water": "Počáteční stav (korekce) l",
        "correction_power": "Počáteční stav (korekce) kWh",
        "correction_gas": "Počáteční stav (korekce) l",
        "correction_heat": "Počáteční stav (korekce)",
        "koeficient_polohy": "Koeficient polohy",
        "koeficient_svetove_strany": "Koeficient světové strany",
        "type": "Typ",
        "add_validation_transmitter": "Přidat kontrolní vysílač",
        "validation_transmitter_explanation": "Kontrolní vysílač je vysílač připojený ke kontrolnímu vodoměru. <a href='https://chytrevodomery.cz/jak-to-funguje/kontrolni-vodomery' target='_blank'>Více informací</a>",
        "whole_building": "-- Celá Budova --",
        "whole_organization": "-- Celá organizace --",
        "add_unit": "Přidat byt/kancelář",
        "edit_unit": "Upravit byt/kancelář",
        "unit_name_placeholder": "eg. Byt č. 13",
        "floor": "Patro",
        "edit_organization": "Editace organizace",
        "company_id": "IČ",
        "dashboard": "Přehled",
        "split_bill": "Rozúčtovat",
        "logout": "Odhlásit se",
        "active_devices_services": "Aktivní zařízení a služby",
        "prepaid_transmitters": "Předplacených vysílačů",
        "increase_limit": "Navýšit limit",
        "active_transmitters": "Aktivních vysílačů",
        "out_of_which_validation": "z toho kontrolních",
        "dashboard_transmitters": "Přehled vysílačů",
        "dashboard_watermeters": "Přehled vodoměrů",
        "dashboard_eletricitymeters": "Přehled elektroměrů",
        "dashboard_gasmeters": "Přehled plynoměrů",
        "dashboard_heatmeters": "Přehled poměrových indikátorů tepla",
        "active_homebases": "Aktivních základen",
        "dashboard_homebases": "Přehled základen",
        "homebases": "Základny",
        "increase_transmitter_limit": "Navýšení limitu vysílačů",
        "increase_transmitter_limit_explanation": "<p>Pro navýšení limitu nás kontaktujte na emailové adrese <a href='roman.hudecek@bonega.cz'>roman.hudecek@bonega.cz</a> nebo na telefonním čísle +420 603 542 347.</p>",
        "count": "Stav",
        "last_data": "Poslední data",
        "first_data": "První data",
        "active": "Aktivní",
        "inactive": "Neaktivní",
        "coming_soon": "V přípravě",
        "login": "Přihlásit",
        "signup": "Registrovat",
        "email": "Email",
        "password": "Heslo",
        "show_password": "Zobrazit heslo",
        "remember": "Zapamatovat",
        "first_time": "Jste zde poprvé?",
        "signup_link": "Registrujte se",
        "signup_heading": "Registrovat nový účet",
        "password_repeat": "Heslo znovu",
        "close": "Zavřít",
        "name_required": "Jméno je vyžadováno.",
        "welcome_in_app": "Vítejte v aplikaci Chytré vodoměry",
        "welcome_in_app_paragraph": "Začněte nejdříve vytvořením nové organizace. Uvedené údaje lze kdykoliv později změnit.",
        "organization_name": "Název organizace",
        "logged_out": "Právě jste byli odhlášeni",
        "log_in_different_account": "Přihlásit se pod jiným účtem",
        "ok": "OK",
        "invite": "Pozvat",
        "registered": "Registrovaný",
        "unregistered": "Neregistrovaný",
        "resend_invitation": "Pozvat znovu",
        "dashboard_share": "Sdílení",
        "timezone": "Časová zóna",
        "sharing_people": "K datům v <b>{object}</b> mají v současné době přístup tito lidé:",
        "sharing_explanation": "Udělte přístup ke sledování spotřeby v <b>{object}</b> dalším lidem. Ceny ani další nastavení nebudou moci měnit.",
        "email_invite_placeholder": "Zadejte email",
        "personal_data_processing": "Zásady zpracování osobních údajů",
        "personal_data_link": "http://www.bonega.cz/firma/GDPR_BONEGA_zakaznici.pdf",
        "yes": "Ano",
        "no": "Ne",
        "field_is_required": "Toto pole je povinné",
        "invalid_format": "Neplatný formát",
        "number_too_small": "Hodnota musí být minimálně {0}",
        "number_too_big": "Hodnota musí být maximálně {0}",
        "invalid_number": "Neplatné číslo",
        "invalid_integer": "Tato hodnota není platné číslo",
        "text_too_small": "Text je příliš krátký. Aktuálně: {0} znaků. Minimálně: {1} znaků",
        "text_too_big": "Text je příliš dlouhý. Aktuálně: {0} znaků. Maximálně: {1} znaků",
        "this_not_text": "Toto není text",
        "this_not_array": "Toto není platné pole",
        "select_min_items": "Vyberte nejméně {0} položek",
        "select_max_items": "Vyberte maximálně {0} položek",
        "invalid_date": "Neplatné datum",
        "date_is_early": "Datum musí být >= {1}",
        "date_is_late": "Datum musí být <= {1}",
        "invalid_email": "Naplatná emailová adresa",
        "invalid_uRL": "Naplatná URL",
        "invalid_card": "Naplatný formát karty",
        "invalid_card_number": "Neplatné číslo karty",
        "invalid_text_contain_number": "Text nesmí obsahovat čísla nebo speciální znaky",
        "invalid_text_contain_spec": "Text nesmí obsahovat speciální znaky",
        "transmitter_not_used": "Musí být použítý alespoň jeden vysílač.",
        "liters_per_hour": "l/h",
        "liters_per_second": "l/s",
        "suspicious_consumption_fluctuation": "Podezřelý výkyv ve spotřebě",
        "suspicious_consumption_fluctuation_desc": "Vyhodnocováno v každou celou hodinu porovnáním s historickými daty. Jednotkový zpětný tok (−1 až −2 l) se ve výchozím stavu nehlásí.",
        "alert_on_negative_consumption": "Upozornit i na zápornou spotřebu",
        "consumption_last_hour": "Spotřeba za poslední hodinu",
        "consumption_last_hour_desc": "Vyhodnocováno v každou celou hodinu",
        "add_alarm": "Přidat alarm",
        "current_flow": "Aktuální průtok",
        "current_flow_desc": "Vyhodnocováno při každém obdržení dat (5/20 minut). Např. prasklé potrubí.",
        "water_consumption_time_interval": "Součet spotřeby v daných hodinách",
        "water_consumption_time_interval_desc": "Např. odhalení protékajícího kohoutku v nočních hodinách. Jedná se o celkový součet spotřeby v daném časovém intervalu.",
        "alarm_data_source": "Zdroj dat",
        "alarm_source_auto": "Automaticky: kontrolní vodoměr, jinak součet struktury",
        "alarm_source_control": "Kontrolní vodoměr",
        "alarm_source_structure": "Součet podřízené struktury",
        "continuous_water_flow": "Nepřetržitý průtok vody",
        "continuous_water_flow_desc": "Např. přetékající vana (doporučujeme pouze při četnosti vysílání po 5 min)",
        "between": "mezi",
        "and": "a",
        "alarms_active": "Alarmy jsou aktivní. Zatím nedošlo k žádné mimořádné události.",
        "alarms_inactive": "Nemáte zatím nastaveny žádné alarmy. Můžete je snadno přidat k libovolné větvi kliknutím na tlačítko",
        "battery_status": "Stav baterie",
        "archive": "Archivovat",
        "archived": "Archivováno",
        "archive_all": "Archivovat vše",
        "water_blue": "Modrý kabel",
        "water_red": "Červený kabel",
        "all_alarms": "Zobrazit všechna hlášení",
        "dashboard_alarms": "Seznam všech alarmů",
        "previous": "Předchozí",
        "next": "Další",
        "page_of": "Stránka {page} / {pages} ({total})",
        "watermeter_label_red": "Číslo vodoměru (Červený kabel)",
        "watermeter_label_blue": "Číslo vodoměru (Modrý kabel)",
        "advanced_settings": "Pokročilé nastavení",
        "organization": "Organizace",
        "download": "Stáhnout",
        "count_physical": "Fyzický stav počitadla",
        "count_total": "Celková spotřeba",
        "count_reverse": "Zpětný tok",
        "watermeter_label": "Číslo vodoměru",
        "powermeter_label": "Číslo elekroměru",
        "gasmeter_label": "Číslo plynoměru",
        "heatmeter_label": "Typ měřidla",
        "split_bill_heading": "Rozúčtování",
        "split_bill_verb": "Rozúčtovat",
        "split_bill_for": "za",
        "split_bill_from": "v období od",
        "split_bill_to": "do",
        "split_bill_in": "v",
        "split_amount": "Rozúčtovaná částka",
        "start_count": "Počáteční stav",
        "end_count": "Konečný stav",
        "consumption": "Spotřeba",
        "currency": "Měna",
        "all_buildings": "Všechny budovy",
        "forgot_password": "Zapomenuté heslo",
        "reset_password": "Změnit heslo",
        "new_password": "Nové heslo",
        "new_password_again": "Zadejte nové heslo znovu",
        "set_new_password": "Nastavit nové heslo",
        "password_too_short": "Heslo je příliš krátké (min. 8 znaků)",
        "passwords_not_match": "Hesla se neshodují",
        "seal_number": "Číslo plomby",
        "help": "Nápověda",
        "help_link": "https://chytrevodomery.cz/systemy-mereni/online-mereni/online-aplikace",
        "water": "Voda",
        "electricity": "Elektřina",
        "gas": "Plyn",
        "heat": "Teplo",
        "valves": "Uzávěry",
        "water_valves": "Uzávěry vody",
        "valve": "Uzávěr",
        "add_valve": "Přidat vodostop",
        "dashboard_valves": "Přehled uzávěrů vody",
        "homebase": "Základna",
        "dashboard_valves_explanation": "Uzávěry vody se zde objeví automaticky, jakmile jsou spárovány se základnou, která je v systému vedena. <a href='https://chytrevodomery.cz/systemy-mereni/automaticky-uzaver-vody' target='blank'>Více informací o chytrých uzávěrech vody</a>.",
        "serial_number_valve": "Sériové číslo uzávěru",
        "status": "Stav",
        "limit_current_flow": "Maximální aktuální průtok",
        "limit_continuous_consumption": "Maximální nepřetržitá spotřeba",
        "limit_dripping": "Maximální úkap",
        "limit_consumption_in_time": "Maximální součet spotřeby za daný čas",
        "valve_closed": "Uzavřen",
        "valve_closed_neutral": "Zavřeno",
        "valve_closing": "Ventil se uzavírá",
        "valve_open": "Otevřen",
        "valve_open_neutral": "Otevřeno",
        "valve_opening": "Ventil se otevírá",
        "valve_half_open": "Polootvřen",
        "valve_half_open_neutral": "Polootvřeno",
        "valve_disconnected": "Odpojen",
        "valve_state_unknown": "Neznámý stav",
        "last_known_state": "Poslední známý stav",
        "valve_status_may_be_stale": "Aktuální stav ventilů se nepodařilo načíst. Zobrazený stav může být několik minut starý.",
        "valve_setting_resending": "Odesílá se nastavení „{setting}“ ({value}) uzávěru {valve} na základnu {homebase}.",
        "valve_setting_resending_generic": "Odesílá se nastavení uzávěru {valve} na základnu {homebase}.",
        "valve_setting_applied": "Nastavení uzávěru {valve} bylo úspěšně uloženo.",
        "no_signal": "Bez signálu",
        "hours": "hodin",
        "minutes": "min",
        "close_valve": "Uzavřít vodu",
        "open_valve": "Otevřít vodu",
        "liters_in": "litrů za",
        "liters_after_number": "litrů",
        "dripping_unit": "hodin po sobě s jakoukoliv spotřebou",
        "close_water_automatically": "Automaticky uzavřít vodu i bez připojení k internetu",
        "when_the_current_flow": "Při okamžitém průtoku větším než",
        "when_continuous_consumption_exceeds": "Při objemu nepřetržité spotřeby vetším než",
        "after": "Pokud se za",
        "consecutive_hours_with_any_consumption": "po sobě jdoucích hodin s nenulovou spotřebou",
        "when_the_total_consumption": "Jakmile je součet spotřeby větší než",
        "settings": "Nastavení",
        "example": "Příklad",
        "current_flow_example": "Prasklé potrubí",
        "continuous_consumption_example": "Přetečná vana",
        "dripping_example": "Protékající záchod nebo pojistný ventil",
        "total_consumption_example": "Omezení denní spotřeby vody ze studny",
        "check_maximum": "Zjistit maximum",
        "maximum_until_now": "Dosavadní maximum",
        "less_then": "menší než",
        "greater_then": "větší než",
        "equals": "=",
        "billing_period": "Zúčtovací období",
        "billing_total_consumption_apartments": "Součet spotřeby naměřené v bytech",
        "billing_total_consumption_control_meter": "Spotřeba naměřená kontrolním vodoměrem organizace",
        "billing_consumption_difference": "Rozdíl měření",
        "billing_price_per": "Rozúčtovaná cena",
        "billing_leftover": "Nerozúčtovaná částka",
        "tenants": "Počet osob",
        "persons": "Počet osob",
        "total_consumption_per_person": "Spotřeba na osobu",
        "daily_consumption_per_person": "Spotřeba na osobu na den",
        "and_for_heating_water": "a za ohřev",
        "cost_of_consumption": "Cena za spotřebu",
        "cost_of_heating_water": "Cena za ohřev",
        "total_cost": "Cena celkem",
        "from": "Od",
        "to": "Do",
        "download_transmitter_data": "Stáhnout data pro vysiláč",
        "alarm_reports": "Alarmová hlášení",
        "liter": "litr",
        "currentDateTime": "Aktuální čas",
        "difference_from_validation_transmitter": "Rozdíl od kontrolního vysílače",
        "validation_transmitter_not_available": "Kontrolní vysílač není dostupný",
        "include_validation_meter_data": "Zahrnout data z kontrolních vysílačů",
        "watts": "watty",
        "power": "kWh",
        "lowest_consumption_in_a_given_row": "nejnižší spotřeba v daném řádku",
        "highest_consumption_in_a_given_row": "nejvyšší spotřeba v daném řádku",
        "reset": "Reset",
        "water_meters": "Vodoměry",
        "electricity_meters": "Elektroměry",
        "electricity_meter": "Elektroměr",
        "gas_meters": "Plynoměry",
        "gas_meter": "Plynoměr",
        "heat_meters": "Poměrové měřiče tepla",
        "heat_meter": "Poměrový měřič tepla",
        "measurement": "Typ měření",
        "water_type": "Typ vody",
        "pulse_count": "1 puls odpovídá",
        "pulse_count_kwh": "1 kWh odpovídá",
        "pulse_count_l": "1 puls odpovídá",
        "pulses": "pulsů",
        "transmitter_id": "Číslo vysílače",
        "signal": "Signál",
        "valve_email_warning": "Upozornění na uzavření ventilu s odkazem na rychlé otevření",
        "internet_required": "vyžaduje připojení k internetu",
        "valve_email_warning_2": "Z bezpečnostních důvodů jsou emaily o uzavření ventilu zasílány vždy bez možnosti deaktivace",
        "add": "Přidat",
        "transmitter_battery_alarm": "Upozornění na nízký stav baterie k vysílačům níže chodí automaticky na email",
        "m3": "m3",
        "heat_unit": "dílek | dílky | dílků",
        "heat_units": "dílky",
        "new_building": "Bude vytvořena nová budova",
        "new_unit": "Bude vytvořen nový byt/kancelář",
        "data_loaded": "Aktualizováno",
        "reload": "Aktualizovat"
    }
}
